module.exports = __webpack_public_path__ + "img/lanmu-02.737f1aa1.jpg";